import React, { useRef, ChangeEvent } from "react";
import axios from "axios";

interface UserData {
  image: string | null;
}

interface AvatarProps {
  data: UserData;
  refreshUser: () => void;
}

const imgeUrl = import.meta.env.VITE_LYRAZONE_IMAGE_URL;

const Avatar: React.FC<AvatarProps> = ({ data,  refreshUser }) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleAvatarClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = async (
    e: ChangeEvent<HTMLInputElement>,
  ): Promise<void> => {
    const file = e.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("userImage", file);

    try {
      await axios.put(
        `${import.meta.env.VITE_LYRAZONE_BASE_URL}/update-avatar`,
        formData,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      refreshUser(); // re-fetch updated user data
    } catch (error) {
      console.error("Avatar upload failed:", error);
    }
  };

  return (
    <div
      className="avatar"
      onClick={handleAvatarClick}
      style={{ cursor: "pointer" }}
    >
      <img
        alt="User"
        src={
          data.image
            ? `${imgeUrl}/uploads/subscribers/${data.image}`
            : "/default-avatar.png"
        }
        className="img-fluid"
      />

      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </div>
  );
};

export default Avatar;
